{
  "selected": "Выбрано: {{count}}",
  "clearSelection": "Снять выделение",
  "selectAll": "Выбрать все строки",
  "selectRow": "Выбрать строку",
  "actions": "Действия"
}
